import { combineReducers } from 'redux';

import { createResourceModuleReducerMap, mlRel } from 'medialoopster/rest';

import { TranscriptRootState } from './types';

export default combineReducers<TranscriptRootState>(
  createResourceModuleReducerMap('transcript', mlRel('transcripts')),
);
